export default [
  {
    name: 'Start-up loan',
    amount: 100_000,
    interestRate: 6,
    repaymentPeriod: 52, // in weeks
  },
  {
    name: 'Investment loan',
    amount: 250_000,
    interestRate: 10,
    repaymentPeriod: 104,
  },
  {
    name: 'Asset loan',
    amount: 500_000,
    interestRate: 14,
    repaymentPeriod: 156,
  },
  {
    name: 'Corporate loan',
    amount: 1_000_000,
    interestRate: 16,
    repaymentPeriod: 208,
  },
];
